// extracted by mini-css-extract-plugin
export default {"wrapper":"FAB_wrapper__UDfN6","tooltip":"FAB_tooltip__0hLBx","popover":"FAB_popover__UTx6J"};